var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { each } from "@al/aku-lc-helpers";
import { merge } from "lodash";
import { action, makeObservable, observable } from "mobx";
import { query } from "../../helpers/query";
var BaseAction = /** @class */ (function () {
    function BaseAction(options) {
        var _this = this;
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "payload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "result", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "runAfter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "makeObservable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                makeObservable(_this, {
                    result: observable,
                    status: observable,
                    setResult: action,
                    updateStatus: action,
                });
            }
        });
        Object.defineProperty(this, "updateStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (status) {
                _this.status = status;
            }
        });
        Object.defineProperty(this, "updatePayload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (payload) {
                _this.payload = merge({}, _this.payload, payload);
            }
        });
        Object.defineProperty(this, "setResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                _this.result = value;
            }
        });
        Object.defineProperty(this, "execute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/];
                });
            }); }
        });
        Object.defineProperty(this, "injectTo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (data) {
                if (_this.inject && _this.inject.injectCallbackData) {
                    var widget = query(_this.inject.target).get();
                    widget === null || widget === void 0 ? void 0 : widget.setInjectData(data);
                }
            }
        });
        Object.defineProperty(this, "executeAfterActions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                if (!_this.runAfter) {
                    return;
                }
                each(_this.runAfter, function (actions, key) {
                    if (_this.status === key) {
                        actions.forEach(function (action) {
                            action();
                        });
                    }
                });
            }
        });
        this.path = options.path;
        this.type = options.type;
        this.payload = options.payload;
        this.status = options.status || "Pending";
        this.runAfter = options.runAfter;
        this.inject = options.inject;
        this.makeObservable();
    }
    return BaseAction;
}());
export { BaseAction };
